import React from 'react';
import { Textarea, Text } from '@cad-arc';
import { CommonControlProps, IntegratedFormControl } from './integrated-form-control';
import { FieldPath, FieldValues } from 'react-hook-form';
import { genericMemo } from '../../common/helpers/memo';
import { useIntegratedForm } from '../use-integrated-form';

type TextareaProps = React.ComponentProps<typeof Textarea>;
type Props<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> = CommonControlProps<TFieldValues, TName> & {
    textareaProps?: TextareaProps;
};

export const FormTextarea = genericMemo(function FormTextarea<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>(props: Props<TFieldValues, TName>): React.ReactElement {
    const integratedForm = useIntegratedForm();
    const { textareaProps, ...integratedFormControlProps } = props;
    const textareaPropsMemo = React.useMemo(() => textareaProps ?? {}, [textareaProps]);
    const renderViewMode = React.useCallback((val: string) => {
        return <Text>{val}</Text>;
    }, []);
    return (
        <IntegratedFormControl {...integratedFormControlProps} renderViewMode={renderViewMode}>
            {(inputProps) => (
                // @ts-expect-error error with ref type, TODO figure this out w/ arc team
                <Textarea
                    style={{
                        minHeight: '3rem',
                        ...(integratedForm.fuzzyMatchingEnabled
                            ? { backgroundColor: 'var(--arc-colors-brand-accent)' }
                            : {}),
                    }}
                    {...inputProps}
                    {...textareaPropsMemo}
                />
            )}
        </IntegratedFormControl>
    );
});
